const getFromWindow = <Result, Fallback>(
  func: () => Result,
  fallback = () => null as Fallback
) => (typeof window !== 'undefined' ? func() : fallback())

export default getFromWindow